import React, {useState, useEffect} from 'react'
import Navbar from '../../Components/Navbar/navbar'
import Topbarsub from '../../Components/Topbar/Topbarsub'
import './leave.css'

const Leave = ({urole, page, addnewoverlay}) => {
  const [searchcriteria, setSearchcriteria] = useState("")
  const [nameSearch, setNameSearch] = useState("")

  const handleSearchCriteria = (incoming) =>{
      setSearchcriteria(incoming)
  }

  const handleaddOverlay = (incoming) =>{
      addnewoverlay(incoming)
  }

  const handleAddNewEmp = () =>{

  }

  const filterSearch = (incoming) =>{
      setNameSearch(incoming.toString())
  }

  useEffect(() => {
      // 👇️ scroll to top on page load
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);
return (
    <div className='appr-leave-container'>
        <Navbar tabtext="Manage Leave" currentab='others'/>
        <Topbarsub serchCriteria={handleSearchCriteria} newEmployee={handleAddNewEmp} currrenTab={page} searchword={filterSearch} addoverlay={handleaddOverlay}/>
    </div>
  )
}

export default Leave